import { Typography, FormHelperText, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CHECK_TYPE_DB } from '@/utility';
import CpdCheckboxCard from '@/components/ui/CpdCheckboxCard';

const CheckTypeSelector = ({
  value,
  onChange,
  disabled,
  error,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const isEcheck = value === CHECK_TYPE_DB.ECHECK;

  return (
    <Box sx={{ my: 2 }}>
      <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1 }}>
        {t('issueCheck.checkType.title')}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <CpdCheckboxCard
          checked={isEcheck}
          selected={isEcheck}
          onChange={() => onChange(CHECK_TYPE_DB.ECHECK)}
          label={t('issueCheck.checkType.echeck.label')}
          description={t('issueCheck.checkType.echeck.description')}
          disabled={disabled}
        />
        <CpdCheckboxCard
          checked={value === CHECK_TYPE_DB.PHYSICAL}
          selected={value === CHECK_TYPE_DB.PHYSICAL}
          onChange={() => onChange(CHECK_TYPE_DB.PHYSICAL)}
          label={t('issueCheck.checkType.physical.label')}
          description={t('issueCheck.checkType.physical.description')}
          disabled={disabled}
        />
      </Box>
      {isEcheck && (
        <Typography
          variant='body2'
          sx={{ mt: 1.5, fontStyle: 'italic', color: 'text.secondary' }}>
          {t('issueCheck.checkType.echeck.note')}
        </Typography>
      )}
      {error && (
        <FormHelperText
          error
          sx={{ fontWeight: 'bold', fontSize: '0.9em', mt: 1 }}>
          {errorMessage}
        </FormHelperText>
      )}
    </Box>
  );
};

export default CheckTypeSelector;
